export const collection = {
  summary: 'Summary',
  append: 'Add another item',
  remove: 'Remove',
  warning: 'Are you sure you would like to remove this item?',
  open: 'Open',
  close: 'Close',
  incomplete: 'There is a problem with this item, please open it and fix the issue(s).',
};
